import React, { useEffect, useRef } from "react";
import { FaPlane } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CallHelpCard from "./CallCard";
import StickyCallCard from "./StickyCallCard";

const airlines = [
  "Asiana Airlines", "LATAM Airlines", "Austrian Airlines", "Egypt Air",
  "Croatia Airlines", "China Eastern Airlines", "El Al Israel Airlines", "Air China Airlines",
  "Mauritius Airlines", "Iceland Airlines", "Kuwait Airways", "Copa Airlines",
  "Aer Lingus Airlines", "Hong Kong Airlines", "Norwegian Airlines", "The Airline Company",
  "Turkish Airlines", "Pegasus Airlines", "Finnair Airlines", "TAP Air Portugal",
  "Frontier Airlines", "Hawaiian Airlines", "Air Serbia", "Swiss International Airlines",
  "Spirit Airlines", "Allegiant Airlines", "Virgin Atlantic Airways", "Sun Country Airlines",
  "LOT Polish Airlines", "Alaska Airlines", "Singapore Airlines", "Brussels Airlines",
  "JetBlue Airlines", "China Southern Airlines", "Air Canada Airlines", "United Airlines",
  "ANA Airlines", "Etihad Airways", "Southwest Airlines", "Qatar Airways",
  "Iberia Airlines", "Delta Airlines", "Qantas Airways", "Lufthansa Airlines",
  "KLM Airlines", "Ethiopian Airlines", "Air Europa Airlines", "Air New Zealand",
  "Emirates Airlines", "Air France Airlines", "Cathay Pacific Airways", "British Airways"
];

const slugify = (name) =>
  name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

const AirlinesList = () => {
  const sectionRef = useRef(null);

  // Fade-in on scroll animation
  useEffect(() => {
    const element = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) element.classList.add("fade-visible");
      },
      { threshold: 0.15 }
    );
    observer.observe(element);
  }, []);

  return (
    <div
      ref={sectionRef}
      className="fade-section bg-[#F9FAF9] rounded-3xl max-w-6xl mx-auto px-6 py-12 shadow-sm"
    >
      <CallHelpCard />

      {/* HEADER */}
      <motion.h2
        className="text-4xl font-extrabold text-center mb-10 text-teal-700 tracking-tight"
        initial={{ opacity: 0, y: -15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        ✈ Explore Airlines
      </motion.h2>

      {/* AIRLINE GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {airlines.map((airline, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.02, duration: 0.5 }}
          >
            <Link
              to={`/airline/${slugify(airline)}`}
              className="
                bg-white 
                border border-gray-200 
                rounded-xl 
                px-4 py-3 
                flex items-center gap-3 
                shadow-sm 
                hover:shadow-lg 
                transition-all 
                duration-300 
                hover:-translate-y-1
                hover:border-teal-400
              "
            >
              <div className="bg-teal-50 p-2 rounded-lg shadow-sm">
                <FaPlane className="text-teal-600 text-lg" />
              </div>
              <span className="font-semibold text-gray-800 text-sm leading-tight">
                {airline}
              </span>
            </Link>
          </motion.div>
        ))}
      </div>

      <StickyCallCard />
    </div>
  );
};

export default AirlinesList;
